import Vue from 'vue';
import _ from 'lodash';

const success = (context, id, i) => {
  context.isModifiedReductions = false;
  const reductionsToDelete = _.cloneDeep(context.reductions);
  const index = reductionsToDelete.findIndex(r => (r.id === id));
  reductionsToDelete.splice(index, 1);
  context.reductions = reductionsToDelete;
  context.modifiedReductions[i].isDeleting = false;
  toastr.success(context.$t('reduction_deleted'));
};

const failed = (context, index, error) => {
  context.modifiedReductions[index].isDeleting = false;
  context.showToasterError(error);
};

export default (context, data, index) => Vue.$http.post('rentals/delete-reduction', data).then((response) => {
  if (response && response.status === 200) {
    success(context, data.reductionId, index);
  }
}).catch(error => {
  failed(context, index, error);
});



// WEBPACK FOOTER //
// ./src/app/services/rental/deleteReduction.js